export class FormFieldErrors {
    Field: string;
    Errors: string[];
}